import axios, { AxiosInstance } from 'axios';
import { API_URL } from '../config';

/**
 * Create an axios instance with default configuration
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Handle API errors consistently
 */
export const handleApiError = (error: any): string => {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  if (error.response?.status === 403 && error.response?.data?.code === "GEOBLOCKED") {
    return error.response.data.error || "Access from your region is not permitted.";
  }
  if (error.message) {
    return error.message;
  }
  return "An unexpected error occurred";
};

